// extracted by mini-css-extract-plugin
module.exports = {"nav-link-effort":"GarageBoard_nav-link-effort__1Px-m","nav-link-effort-pointer":"GarageBoard_nav-link-effort-pointer__2e77h"};